import { API } from '..';
import { ReportPostModel } from '../../models/report-post-model';

export const reportPostApi = (params: ReportPostModel) => {
  return new Promise<any>((resolve, reject) => {
    API.post(`/report/user-service/create-report`, params)
      .then((res) => {
        console.log('🚀 ~ .then ~ res:', res);

        resolve(res.data);
      })
      .catch(reject);
  });
};
export const countReportPostApi = (postId: string, reportPostValue: string) => {
  return new Promise<number>((resolve, reject) => {
    API.get(
      `/v1/user-service/users/count-report?postId=${postId}&reportPostValue=${reportPostValue}`
    )
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const hiddenPostApi = (
  postId: string,
  lastReportId: string,
  lastReportDate: string,
  amountReport: string
) => {
  return new Promise<boolean>((resolve, reject) => {
    API.put(`/v1/post-service/posts/update-report-detail`, {
      postId,
      isHiddenByReport: true,
      lastReportId,
      lastReportDate,
      amountReport,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
/** Admin ẩn bài sau khi duyệt báo cáo: route admin của post-service (cần Content.Moderate). */
export const adminHidePostByReportApi = (postId: string, lastReportId: string) =>
  API.put<boolean>(`/v1/post-service/admin/update-report-detail`, {
    postId,
    isHiddenByReport: true,
    lastReportId,
    lastReportDate: new Date().toISOString(),
    amountReport: 0, // 0 = giữ nguyên tổng số báo cáo đang có
  }).then((res) => {
    if (res.data !== true) throw new Error('Không tìm thấy bài viết.');
    return res.data;
  });

export const hiddenCommentApi = (
  id: string,
  lastReportId: string,
  lastReportDate: string,
  commentType: string
) => {
  const type = parseInt(commentType || '0', 10);
  return new Promise<boolean>((resolve, reject) => {
    API.post(`/v1/post-service/comments/update-report-detail`, {
      id,
      isHiddenByReport: true,
      lastReportId,
      lastReportDate,
      commentType: type,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const unHiddenCommentApi = (
  id: string,
  lastReportId: string,
  lastReportDate: string,
  commentType: string
) => {
  const type = parseInt(commentType || '0', 10);
  return new Promise<boolean>((resolve, reject) => {
    API.post(`/v1/post-service/comments/update-report-detail`, {
      id,
      isHiddenByReport: false,
      lastReportId,
      lastReportDate,
      commentType: type,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
